export function removeHTMLTags(str: string) {
	if ((str===null) || (str===''))
		return "";
	else
		str = str.toString();
		str = str.replace(/&nbsp;/g, ' ');

	// Regular expression to identify HTML tags in
	// the input string. Replacing the identified
	// HTML tag with a null string.
	return str.replace( /(<([^>]+)>)/ig, '');
}
